import axios from 'axios';
import { useEffect, useState } from 'react';

export async function getTSPProviders() {
	return axios.get('/api/tspprovider');
}

export const useTSPProviders = () => {
	const [tspProviders, setTspProviders] = useState<any[]>([]);
	const [isComplete, setIsComplete] = useState(false);
    useEffect(() => {
		const result = async () =>
			getTSPProviders().then(
				res => {
					setTspProviders(res.data);
					setIsComplete(true);
				},
				err => Promise.reject(err)
			);
		result();
	}, []);
	return { tspProviders: { data: tspProviders, isComplete: isComplete } };
};
